import Spinner from '../Spinner';
import './GenericFallback.scss';

export default function GenericFallback() {
  return (
    <div className="GenericFallback">
      <Spinner size="small" />
    </div>
  );
}
